/* eslint-disable no-template-curly-in-string */
import React from 'react';
import { translations as _ } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { useFormContext } from 'react-hook-form';

interface IFormFieldProps {
  fieldName: string;
  type?: string;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
  defaultValue?: string;
  maxLength?: number;
}
export default function FormField({
  fieldName,
  type,
  disabled,
  defaultValue,
  placeholder,
  required = false,
  maxLength,
}: IFormFieldProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const i18nKey = _.global.form;

  return (
    <div className="field">
      <fieldset
        className={cx({
          error: errors[fieldName],
        })}
      >
        <legend>
          {t(i18nKey[`${fieldName}Label`])}
          {required ? ' *' : ''}
        </legend>
        <input
          className={cx('field', { disabled: disabled })}
          defaultValue={defaultValue}
          id={fieldName}
          placeholder={placeholder}
          onKeyDown={evt => {
            if (type === 'number')
              ['e', 'E', '+', '-', '.', ','].includes(evt.key) &&
                evt.preventDefault();
          }}
          type={type || 'text'}
          disabled={disabled}
          {...register(
            fieldName as '`${string}` | `${string}.${string}` | `${string}.${number}`',
            {
              required: required,
              ...(maxLength
                ? {
                    maxLength: {
                      value: maxLength,
                      message: t(i18nKey.errors.tooLong),
                    },
                  }
                : null),
            },
          )}
        />
      </fieldset>
      {errors[fieldName] && errors[fieldName].type === 'required' && (
        <span className="error">{t(i18nKey.errors.required)}</span>
      )}
      {errors[fieldName] && errors[fieldName].type === 'maxLength' && (
        <span className="error">{errors[fieldName].message}</span>
      )}
    </div>
  );
}
